const AUTH_CHANNEL_NAME = "auth";
const LOGOUT_EVENT = "logout";

let authChannel = null;

function getAuthChannel() {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") {
    return null;
  }

  if (!authChannel) {
    authChannel = new BroadcastChannel(AUTH_CHANNEL_NAME);
  }

  return authChannel;
}

export function emitLogout(payload = {}) {
  const channel = getAuthChannel();
  if (!channel) {
    return;
  }
  channel.postMessage({
    type: LOGOUT_EVENT,
    payload,
    at: Date.now(),
  });
}

export function onLogout(listener) {
  const channel = getAuthChannel();
  if (!channel || typeof listener !== "function") {
    return () => {};
  }

  const handler = (event) => {
    if (event?.data?.type === LOGOUT_EVENT) {
      listener(event.data.payload || {});
    }
  };

  channel.addEventListener("message", handler);
  return () => channel.removeEventListener("message", handler);
}

export function closeAuthEvents() {
  if (authChannel) {
    authChannel.close();
    authChannel = null;
  }
}
